export const DASHBOARD_ROUTE = "/";
export const LINKS_ROUTE = "/links";
export const WALLOFLOVE = "/wall_of_love";
export const SUBSCRIPTION_PLANS = "/plans";
export const CHECKOUT = "/checkout";
export const ONBOARDING_ROUTE = "/onboarding";
export const PAYOUTS_ROUTE = "/payouts";
export const CALENDAR_ROUTE = "/calendar";
export const RESOURCES = "/resources";
export const CUSTOMISATION_ROUTE = "/customization";
export const PAGES_ROUTE = "/pages";
export const INVOICE_ROUTE = "/invoice";
export const LEADS_ROUTE = "/leads";
export const REPORTS_ROUTE = "/reports";
export const REPORTS_ALL_SALES = "/all_sales";
export const INTEGRATION_ROUTE = "/integrations";
export const FORMS_ROUTE = "/forms";
export const CUSTOMER_PROFILE = "/customer_profile";
export const FORMS_RESPONSES = "/forms/responses/:formId";
export const ALL_CUSTOMERS_ROUTE = "/allcustomers";
export const TESTIMONIALS_ROUTE = "/testimonials";
export const NEW_PAGE_ROUTE = "/pages/:offeringId";
export const LEADS_PAGE_ROUTE = "/pages/:offeringId/dashboard/leads";
export const OFFERING_BOOKINGS = "/pages/:offeringId/dashboard/bookings";
export const ACCOUNT_CENTER_ROUTE = "/account_center";
export const NEW_EDIT_FORM = "/newform/:formId";
export const FORM_PREVIEW = "/form/:formId/preview";
export const SUBSCRIPTION_UPGRADE = "/subscription_update";
export const TRACK_ATTENDANCE = "/pages/:offeringId/attendance";
export const MARKETING = "/marketing";
export const ADD_COUPON = "/marketing/:featureId/addCoupon";
export const EDIT_COUPON = "/marketing/coupon/:featureId/:couponId";
export const BROADCAST = "/broadcast";
export const ONBOARDING_INSTAGRAM_INTEGRATION = "/instagram_integration";
export const INSTAGRAM = "/instagram";
export const INSTAGRAM_AUTOMATIONS = "/instagram/instagram_feature";
export const INSTAGRAM_CONTACTS = "/instagram/instagram_contacts";
export const INSTAGRAM_CREDITS = "/instagram/instagram_credits";
export const INSTAGRAM_PRODUCT_CATALOGUE = "/instagram/product_catalogue";
export const INSTAGRAM_CAMPAGINS = "/instagram_campagins";
export const INSTAGRAM_MY_CAMPAGINS = "/instagram_campagins/my_campagins";
export const PRODUCT_CATALOGUE = "/product_catalogue";
export const INSTAGRAM_CAMPAIGNS = "/instagram_campagins";
export const UPDATE_INSTAGRAM_CAMPAIGNS = "/instagram_campagins/:campaignId";
export const CREATE_INSTAGRAM_CAMPAIGNS =
  "/instagram_campagins/my_campagins/new";
export const INSTAGRAM_MY_CAMPAIGNS = "/instagram_campagins/my_campagins";
export const INSTAGRAM_COLLABORATIONS = "/instagram_campagins/collaborations";
export const INSTAGRAM_COLLABORATIONS_DETAILS =
  "/instagram_campagins/collaborations/:instaUsername/:campaignId";
export const INSTAGRAM_CAMPAGIN_STATS =
  "/instagram_campagins/:campaignId/stats";
export const INSTAGRAM_MANAGED_CAMPAIGNS =
  "/instagram_campagins/managed_campaigns";
export const INSTAGRAM_UPDATE_MANAGED_CAMPAIGN =
  "/instagram_campagins/managed_campaigns/:campaignId";

export const CAMPAIGN_PRICING_PAGE = "/instagram_campaigns/pricing";
export const CAMPAIGN_FIRST_VIEW_PAGE = "/instagram_campaigns/intro";
